import {
  useQueryClient,
  type InfiniteData,
  type QueryKey,
} from '@tanstack/react-query'

import type { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Event,
  MutationCreateEventArgs,
  PaginatedEvent,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getAllEventQueries } from './utils.js'

export const useCreateEvent = (options?: {
  useMutationOptions?: UseMutationOptions<
    Event,
    ClientError,
    MutationCreateEventArgs,
    { snapshot: [QueryKey, InfiniteData<PaginatedEvent>][] }
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<
    Event,
    ClientError,
    MutationCreateEventArgs,
    { snapshot: [QueryKey, InfiniteData<PaginatedEvent>][] }
  >(
    (input: MutationCreateEventArgs) => {
      return client.events.create(input)
    },
    {
      ...useMutationOptions,
      onSuccess: (data, variables, context) => {
        const eventQueries = getAllEventQueries(queryClient)
        eventQueries.forEach(query => query.invalidate())

        useMutationOptions?.onSuccess?.(data, variables, context)
      },
    },
  )
}
